import {BaseEntity,Column,CreateDateColumn,Entity,Index, UpdateDateColumn, VersionColumn} from "typeorm";

@Entity("procurement_types")
 
export class ProcurementType {

    @Column("int",{
        primary:true,
        name:"procurement_type_id"
        })
    procurementTypeId:Number;
        

    @Column("varchar",{ 
        nullable:false,
        length:30,
        name:"procurement_type"
        })
    procurementType:string;

    @CreateDateColumn({name:"created_at"})
    createdAt: Date;


    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name:"updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @Column("boolean",{ 
        nullable:false,
        default: true,
        name:"status"
        })
    status:boolean | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
}

